import router from './router'
import MainMessages from './localization'

export default {
  router,
  localization: MainMessages,
}
